<div class="range-slider-container">
    <input
        type="range"
        [min]="min"
        [max]="max"
        [value]="val"
        [step]="step"
        class="slider"
        id="myRange"
        (change)="onChange($event)"
    />
</div>
